import React, { useState } from 'react';
import { useFormSubmit } from '../context/FormSubmitContext';
import { LegalTermsModal } from './LegalTermsModal';

const submitButtonClass =
  'shrink-0 px-5 py-1.5 rounded bg-[#eda448] text-gray-900 text-sm font-semibold hover:bg-[#d8932e] transition-colors disabled:opacity-60 disabled:cursor-not-allowed';

export function PrintFormButton({ className = '' }) {
  const { printForm, submitting, printing } = useFormSubmit();
  const busy = submitting || printing;

  return (
    <button
      type="button"
      data-form-print-btn
      disabled={busy}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        printForm();
      }}
      className={`${submitButtonClass} ${className}`}
    >
      {printing ? 'Printing…' : 'Print'}
    </button>
  );
}

export function SubmitDetailsButton({ className = '' }) {
  const { submitForm, submitting, printing, message, selectedSiteId, setMessage } = useFormSubmit();
  const [showLegalTerms, setShowLegalTerms] = useState(false);
  const busy = submitting || printing;

  const statusClass =
    message?.type === 'success'
      ? 'text-green-700'
      : message?.type === 'error'
        ? 'text-red-700'
        : '';

  const statusText = submitting
    ? 'Saving…'
    : printing
      ? 'Preparing print…'
      : message?.type === 'success'
        ? 'Details saved'
        : message?.text;

  return (
    <div className={`flex items-center justify-end gap-3 w-full ${className}`}>
      {(submitting || printing || message) && (
        <span
          className={`text-sm font-medium ${busy ? 'text-gray-600' : statusClass}`}
          role="status"
        >
          {statusText}
        </span>
      )}
      <button
        type="button"
        data-form-submit-btn
        disabled={busy}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!selectedSiteId) {
            setMessage({
              type: 'error',
              text: 'Please select a Location / Site before submitting.',
            });
            return;
          }
          setShowLegalTerms(true);
        }}
        className={submitButtonClass}
      >
        {submitting ? 'Saving PDF…' : 'Submit Details'}
      </button>
      {showLegalTerms ? (
        <LegalTermsModal
          onClose={() => setShowLegalTerms(false)}
          onAgree={() => {
            setShowLegalTerms(false);
            submitForm();
          }}
        />
      ) : null}
    </div>
  );
}

/** @deprecated Use SubmitDetailsButton */
export function FormFooterActions(props) {
  return <SubmitDetailsButton {...props} />;
}

export function FormSubmitFeedback() {
  return null;
}
